"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var _safeConfig = require("../../packages/config/safe-config");
var _jsxRuntime = require("react/jsx-runtime");
const SCROLL_PADDING_BY_CONFIG_KEY = {
  disabled: "0px",
  enabled: "60px"
};
const GlobalStyle = (0, _styledComponents.createGlobalStyle)`
  ${function (_ref) {
  let {
    scrollPadding
  } = _ref;
  return `
    html {
      scroll-padding-top: ${scrollPadding};
    }
  `;
}}
`;

/**
 * Component that applies a global scroll-padding-top style based on the page-level configuration.
 * @returns {JSX.Element | null}
 */
const ScrollPaddingTop = function () {
  const scrollPaddingKey = (0, _safeConfig.useSafeConfigValue)("REACT_APP_SCROLL_PADDING");
  if (scrollPaddingKey === "noSelection") {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(GlobalStyle, {
    scrollPadding: SCROLL_PADDING_BY_CONFIG_KEY[scrollPaddingKey],
    "data-testid": "ScrollPaddingTop"
  });
};
var _default = exports.default = ScrollPaddingTop;